module.exports = __webpack_public_path__ + "img/cbo.5d55b15a.jpg";